module.exports = __webpack_public_path__ + "static/nicolemoudaber_0-9cf8b0aaf823157198f6c7fa669f2c7d.jpg";